export default __webpack_public_path__ + "static/media/pin-tai-po-geoheritage-centre.0c400821.png";